import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AutofillmsmeService } from '../../../../../shared/services/autofillmsme.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../../confirmation-dialog/confirmation-dialog.component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { State } from '../../../../../shared/models/MSMEStateModel';
import { Interest } from '../../../../../shared/models/MSMEProfileInterest';
import { DatePipe } from '@angular/common';
import { finalize } from 'rxjs';


@Component({
  selector: 'app-personaldetails',
  templateUrl: './personaldetails.component.html',
  styleUrl: './personaldetails.component.css'
})
export class PersonaldetailsComponent {
  form: FormGroup;
  data: any[];
  maxDate: string;
  filteredData: any;
  isButtonDisabled = false;
  isWhatsAppSelected: boolean = false;
  isVerifyButtonDisabled = false;
  isResendButtonDisabled = false;
  socialCategory: any[] = [];
  enterpriseType: any[] = [];
  niclist: any[] = [];
  nicListDetails: any[] = [];
  organizationType: any[] = [];
  maharashtraState: State[] = [];
  allStates: State[] = [];
  districtsBasedOnState: any[] = [];
  blocksBasedonDistricts: any[] = [];
  otpError: boolean = false;
  otpSuccess: boolean = false;
  formData: any;
  udyamnumber: any = sessionStorage.getItem("udyamRegistrationNumber");
  isUdyamVerified: boolean = sessionStorage.getItem('isUdyamVerified') ==='true'? true: false;
  mobNum: string | null = sessionStorage.getItem('ownersMobileNumber');
  email: string |null= sessionStorage.getItem('email');
  plantUnits: { name: string; location: string }[] = [];
  nicForm: FormGroup;
  nicEntries: any[] = [];
  showIECField: boolean = false;

  disableRemove: boolean = false;
  selectedPairs: {
    interestId: string,
    interestName: string
  }[] = [];
  uploadUdyamError: string | null = null;
  uploadError: string | null = null;
  certificateFile: File | null = null;
  nicCode: string | null = null;
  previousUdyamFileName: string | null = null;
  interests: Interest[] = [];         // Holds all interests
  filteredInterests: Interest[] = []; // Holds filtered interests (for left box)
  selectedInterests: Interest[] = [];

  filteredInterestsPrev: Interest[] = [];
  nicCodes: string = "";
  plants: { name: string; location: string }[] = [];
  typeOfEnterprise: any;

  fromPreviewPage: boolean = false;


  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  loadingSequence: boolean = false;
  constructor(public dialog: MatDialog,
    private router: Router, private apiService: ApiService,
    private msme_serv: AutofillmsmeService,
    private route: ActivatedRoute, private fb: FormBuilder, private commonService: CommonService, private toastrService: ToastrService
    , private datePipe: DatePipe) {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate() - 1).padStart(2, '0');

    // Set the maxDate as today's date
    this.maxDate = `${yyyy}-${mm}-${dd}`;

    this.data = [];
    this.nicForm = this.fb.group({
      nicCode: [''],
      sectorName: [''],
      divisionName: [''],
      groupName: [''],
      className: [''],
      subClassName: ['']
    });

    this.form = new FormGroup({
      nameOfEnterprise: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithHypenCommaSlash)]),
      name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithSpacePattern)]),
      typeOfEnterprise: new FormControl(null, [Validators.required,]),
      typeofOrganization: new FormControl(null, [Validators.required,]),
      /*ownersMobileNumber: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(this.commonService.mobilePattern)]),*/
      ownersMobileNumber: new FormControl({ value: '', disabled: true }),
      isWhatsAppEnabled: new FormControl(false),
      alternateContactNumber: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(this.commonService.mobilePattern)]),
      gender: new FormControl('', [Validators.required,]),
      socialCategory: new FormControl(null, [Validators.required,]),
      areYouAPersonWithDisabilities: new FormControl('', [Validators.required]),
      nicCode: new FormControl(null, [Validators.minLength(3), Validators.maxLength(10)]),
      //areYouAnExporter: new FormControl('', [Validators.required]),
      //iec: new FormControl('', [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(this.commonService.iecCodePattern)]),
      officialAddressOfEnterprise: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(255), Validators.pattern(this.commonService.addressPattern)]),
      stateId: new FormControl('', [Validators.required]),
      districtId: new FormControl(null, [Validators.required,]),
      block: new FormControl(null, []),
      city: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern(this.commonService.city)]),
      pin: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(this.commonService.pincodePattern)]),
      dic: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern(this.commonService.city)]),
      plantUnitName: new FormControl('', [Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.addressPattern)]),
      locationOfPlantUnit: new FormControl('', [Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.addressPattern)]),
      dateOfIncorporation: new FormControl(''),
      dateOfCommencement: new FormControl(''),
      majorActivity: new FormControl('', [Validators.required,]),
      investmentCost: new FormControl(''),
      interestsId: new FormControl(''),
      udyamCertificate: new FormControl('', Validators.required),
      documents: this.fb.array([this.createDocument()]),
      email : new FormControl('')
    });

    //const exporterControl = this.form.get('areYouAnExporter');
    //if (exporterControl) {
    //  exporterControl.valueChanges.subscribe(value => {
    //    this.showIECField = value === true;

    //    const iecControl = this.form.get('iec');
    //    if (iecControl) {
    //      if (value === true) {
    //        iecControl.setValidators([Validators.required, Validators.minLength(10)]);
    //      } else {
    //        this.form.get('iec')?.setValue('');
    //        iecControl.clearValidators();
    //      }
    //      iecControl.updateValueAndValidity();
    //    }
    //  });
    //}
  }

  disableFormControls() {
    const controlsToDisable = [
      'ownersMobileNumber',
      'name',      
      'officialAddressOfEnterprise',
      'nameOfEnterprise',
      'dateOfIncorporation',
      'dateOfCommencement',
      'pin',
      'typeOfEnterprise',
      'typeofOrganization',
      'socialCategory',
      'gender',
      'city',
      'majorActivity',
      'stateId',
      'districtId',
      'block',
      'areYouAPersonWithDisabilities',
      'dic'
    ];

    controlsToDisable.forEach(controlName => {
      const control = this.form.get(controlName);
      if (control) {
        control.disable();
      }
    });
  }

  enableFormControls() {
    const controlsToEnable = [
      'ownersMobileNumber',
      'name',
      'officialAddressOfEnterprise',
      'nameOfEnterprise',
      'dateOfIncorporation',
      'dateOfCommencement',
      'pin',
      'typeOfEnterprise',
      'typeofOrganization',
      'socialCategory',
      'gender',
      'city',
      'majorActivity',
      'stateId',
      'districtId',
      'block',
      'areYouAPersonWithDisabilities',
      'dic'
    ];

    controlsToEnable.forEach(controlName => {
      const control = this.form.get(controlName);
      if (control) {
        control.enable();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.scrollContainer.nativeElement.scrollTop = 0; // Scroll to top of container
      }
    });

    await this.loadInterests();
    await this.loadEnterpriseType();
    await this.loadOrganizationType();
    await this.loadSocialCategory();
    await this.loadNICList();
    await this.loadStates();
    this.onWhatsAppChange();

    this.route.paramMap.subscribe(params => {
      this.formData = history.state.formData;
     this.fromPreviewPage = history.state.fromPreviewPage;     

      if (this.formData && this.formData.ownersMobileNumber) {
        this.form.patchValue({
          ownersMobileNumber: this.mobNum
        });
      }

      // Wait for 5 seconds and then execute the second method
      /*setTimeout(() => {*/
        if (this.fromPreviewPage) {
          const incomingFormData = history.state?.formData;
          if (incomingFormData) {
            this.form.patchValue({
              nameOfEnterprise: incomingFormData.nameOfEnterprise,
              name: incomingFormData.name,
              typeOfEnterprise: incomingFormData.typeOfEnterprise,
              typeofOrganization: incomingFormData.typeofOrganization,
              isWhatsAppEnabled: incomingFormData.isWhatsAppEnabled,
              alternateContactNumber: incomingFormData.alternateContactNumber,
              gender: incomingFormData.gender,
              socialCategory: incomingFormData.socialCategory,
              areYouAPersonWithDisabilities: incomingFormData.areYouAPersonWithDisabilities,
              //areYouAnExporter: incomingFormData.areYouAnExporter,
              iec: incomingFormData.iec,
              officialAddressOfEnterprise: incomingFormData.officialAddressOfEnterprise,
              districtId: incomingFormData.districtId,
              city: incomingFormData.city,
              pin: incomingFormData.pin,
              dic: incomingFormData.dic,
              dateOfIncorporation: incomingFormData.dateOfIncorporation,
              dateOfCommencement: incomingFormData.dateOfCommencement,
              majorActivity: incomingFormData.majorActivity,
              investmentCost: incomingFormData.investmentCost,
              email: incomingFormData.email
            });
            this.filteredInterestsPrev = incomingFormData.msmeUserInterests;
            //const exporterControl = this.form.get('areYouAnExporter');
            //if (exporterControl) {
            //  exporterControl.valueChanges.subscribe(value => {
            //    this.showIECField = value === true;

            //    const iecControl = this.form.get('iec');
            //    if (iecControl) {
            //      if (value === true) {
            //        iecControl.setValidators([Validators.required, Validators.minLength(3)]);
            //      } else {
            //        this.form.get('iec')?.setValue('');
            //        iecControl.clearValidators();
            //        iecControl.updateValueAndValidity();
            //      }
            //      iecControl.updateValueAndValidity();
            //    }
            //  });
            //}

            if (incomingFormData.isWhatsAppEnabled) {
              this.form.get('alternateContactNumber')?.setValue('');
              this.isWhatsAppSelected = true;
            } else {
              this.form.get('alternateContactNumber')?.setValue(incomingFormData.alternateContactNumber);
              this.isWhatsAppSelected = false;
            }
            // Handle NIC Code Details
            if (incomingFormData.msmeUserNICCodeDetails) {
              this.nicEntries = [...incomingFormData.msmeUserNICCodeDetails];
            }
            //Handle interests Details right
            if (incomingFormData.msmeUserInterests) {
              this.selectedInterests = [...incomingFormData.msmeUserInterests];
            }

            // Populate filteredInterests with all interests except the selected ones
            this.filteredInterests = this.interests.filter((interest: Interest) =>
              !this.selectedInterests.some((selected: Interest) => selected.interestId === interest.interestId)
            );

            // Handle plant unit Details
            if (incomingFormData.msmeUserPlantUnitDetails) {
              this.plantUnits = [...incomingFormData.msmeUserPlantUnitDetails];
            }
            if (incomingFormData.udyamCertificateFile) {
              this.previousUdyamFileName = incomingFormData.udyamCertificateFile.name;
            }

            if (incomingFormData.districtId) {
              this.GetBlocksOnBack(incomingFormData.districtId);
              this.form.patchValue({
                block: incomingFormData.block,
              });
            }

            if (incomingFormData.ownersMobileNumber) {
              this.form.get('ownersMobileNumber')?.setValue(incomingFormData.ownersMobileNumber);
              //this.form.get('ownersMobileNumber')?.disable();
            }

            const documentsData = incomingFormData.documents; // Assuming this is an array

            // Clear the FormArray first
            const documentsFormArray = this.form.get('documents') as FormArray;
            documentsFormArray.clear();

            // Add a FormGroup for each document
            documentsData.forEach((document: any) => {
              documentsFormArray.push(this.createDocument());
            });

            this.form.get('udyamCertificate')?.clearValidators();
            this.form.get('udyamCertificate')?.updateValueAndValidity();

            // Now patch the values
            documentsFormArray.patchValue(documentsData);

            if (incomingFormData.udyamCertificateFile) {
              this.onUdyamFileChangeBack(incomingFormData.udyamCertificateFile);
            }
          }
        } 
      
    });

    //if (this.IsUdyamVerified === 'true') {
    //  this.data = await this.msme_serv.getDataByUdyamNumber(this.udyamnumber);
    //  this.calljson();
    //} 

    if (!this.fromPreviewPage && this.isUdyamVerified) {
      const dtoUdyam = {
        authToken: "",
        clientId: "",
        udyamNo: this.udyamnumber,
        mobile: this.mobNum
      }
      this.loadingSequence = true;

      this.apiService.postRequest(API_ENDPOINTS.UDYAM.VERIFYUDYAM, dtoUdyam).subscribe(
        response => {
          if (response.isResponse === 'Y') {
            this.data = response.data;
            this.calljson();
            this.loadingSequence = false;
          } else {
            this.toastrService.error(response.msg);
            this.loadingSequence = false;
          }
        })
      finalize(() => {
        this.loadingSequence = false;  // Stop the loader after both calls complete (success or error)
      });
    } else {
      this.loadingSequence = false;
      this.enableFormControls();
    }

    if (this.fromPreviewPage && this.isUdyamVerified) {
      this.disableFormControls();
    } else {
      this.enableFormControls();
      }


    this.disableRemove = sessionStorage.getItem('isUdyamVerified') === 'true' ? true : false;
    if (this.disableRemove) {
      this.form.get('nicCode')?.disable();
      this.form.get('plantUnitName')?.disable();
      this.form.get('locationOfPlantUnit')?.disable();
    }
  }
  get f() {
    return this.form.controls;
  }

  //This method is used for Autofill.json
  //calljson() {
  //  this.filteredData = this.data;
  //  if (this.filteredData) {
  //    this.form.patchValue(this.filteredData);
  //    this.disableFormControls();
  //  }
  //}
  
  calljson() {
    this.disableFormControls();
    this.filteredData = this.data;   

    let dateOfCommencement: string | null = '';
    let dateOfIncorporation: string | null = '';    

    if (this.isValidDate(this.filteredData.dateOfCommencement)) {
      const cDate = this.filteredData.dateOfCommencement.split('/');
      dateOfCommencement = `${cDate[2]}-${cDate[1]}-${cDate[0]}`;
    } else {
        dateOfCommencement = null;
    }

    if (this.isValidDate(this.filteredData.dateOfIncorporation)) {
      const cDate = this.filteredData.dateOfIncorporation.split('/');
      dateOfIncorporation = `${cDate[2]}-${cDate[1]}-${cDate[0]}`;
    } else {
      dateOfIncorporation = null;
    }      

    if (this.filteredData.activities) {      
      this.filteredData.activities.forEach((activity:any) => {
        this.nicCodes += activity.niC5DigitId + ',';        
      });
    }

    if (this.filteredData.plantLocations) {
        this.filteredData.plantLocations.forEach((plant: any) => {
          this.form.get('plantUnitName')?.setValue(plant.name);
          this.form.get('locationOfPlantUnit')?.setValue(plant.location);
          this.addPlantUnit();
        });
    }  
      var data = {
        typeEnterprise: this.filteredData.enterpriseType,
        typeOrganization: this.filteredData.organisationType,
        socialCategory: this.filteredData.socialCategory,
        districtCode : this.filteredData.districtId,
        blockName: this.filteredData.block,
        nicCodes: this.nicCodes,
      }

      this.apiService.getRequest(API_ENDPOINTS.MSME.GETMSMEPERSONALDETAILS,  data ).subscribe(
        (result) => {
          
          if (result.status) {
            if (result.data[3].length>0) {
              for (let i = 0; i < result.data[3].length; i++) {
                const item = result.data[3][i];
                
                const newEntry = {
                  nicId: item.nicId, 
                  nicCode: item.nicCode,
                  sector: item.sectorName,
                  divisionDescription: item.divisionName,
                  groupDescription: item.groupName,
                  class: item.className,
                  subClass: item.subClassName
                };
                
                const exists = this.nicEntries.some(entry => entry.nicCode === newEntry.nicCode);
                if (!exists) {
                  this.nicEntries.push(newEntry);
                } else {
                  this.toastrService.error('This NIC Code is already added.');
                }
              }
            }
          }
          this.GetBlocksForUdyamPortal(this.filteredData.districtId, this.filteredData.block)
          this.form.patchValue({
            ...this.filteredData,
            dateOfCommencement: dateOfCommencement ? dateOfCommencement : null,
            dateOfIncorporation: dateOfIncorporation ? dateOfIncorporation :null,
            typeOfEnterprise: result.data[0][0].id ? result.data[0][0].id :null,
            typeofOrganization: result.data[1][0].id ? result.data[1][0].id :null,
            socialCategory: result?.data[2][0]?.id ? result?.data[2][0]?.id :null,
            stateId: 27,
            districtId: result?.data[4][0]?.id ? result?.data[4][0]?.id : null,
            block: result?.data[5][0]?.id ? result?.data[5][0]?.id : null,
            dic: this.filteredData.district
          });
          const isDisabled = this.filteredData.areYouAPersonWithDisabilities.toLowerCase() !== 'yes' ;
          this.form.patchValue({ areYouAPersonWithDisabilities: !isDisabled });
          if (isDisabled) {
            this.form.get('areYouAPersonWithDisabilities')?.enable();
          }
          //this.disableFormControls();

        }

      );     
  }

  isValidDate(dateString: string): boolean {

    const date = new Date(dateString?.split('/')?.reverse()?.join('-')); // Convert to YYYY-MM-DD
    return !isNaN(date?.getTime()); // Return true if the date is valid
  }

  async GetBlocksForUdyamPortal(d: any, b: any): Promise<void> {
    const districtId = d;
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.BLOCK.GETBLOCKBASEDONDISTRCIT, { DistrictId: districtId }).subscribe(
      (result) => {
        if (result.status) {
          this.blocksBasedonDistricts = result.data;
          const block = this.blocksBasedonDistricts.find(type => type.blockName == b);
          this.form.patchValue({ block: block ? block.blockId : null });
        }
      }
    );

  }

  async loadNICList(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.NIC.GETNICLIST).subscribe(
      (result) => {
        if (result.status) {
          this.niclist = result.data;
        }
      }
    );
  }  

  async loadEnterpriseType(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETENTERPRISETYPE).subscribe(
      (result) => {
        if (result.status) {
          this.enterpriseType = result.data;
        }
      }
    );
  }

  async loadSocialCategory(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETSOCIALCATEGORY).subscribe(
      (result) => {
        if (result.status) {
          this.socialCategory = result.data;
        }
      }
    );
  }

  async loadInterests(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INTEREST.GETLIST).subscribe(
      (result) => {
        if (result.status) {
          this.interests = result.data;
          this.filteredInterests = [...this.interests];

          if (this.filteredInterestsPrev != undefined && this.filteredInterestsPrev.length > 0) {
            // Populate filteredInterests with all interests except the selected ones
            this.filteredInterests = this.interests.filter((interest: Interest) =>
              !this.selectedInterests.some((selected: Interest) => selected.interestId === interest.interestId)
            );
          }
        }
      }
    );
  }

  async loadStates(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.STATE.GETLIST).subscribe(
      (result) => {
        if (result.status) {
          this.allStates = result.data;
          this.maharashtraState = this.allStates.filter((state: State) => state.StateName === 'MAHARASHTRA');
          const maharashtra = this.maharashtraState[0]; // Since we are only keeping Maharashtra
          if (maharashtra) {
            this.form.patchValue({ stateId: maharashtra.stateCode });
          }
          this.loadDistricts();
        }
      }
    );  
  }

  async loadDistricts(): Promise<void> {
    const stateId = this.maharashtraState[0].stateCode;
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.DISTRICT.GETDISTRICTBASEDONSTATE, { StateID: stateId }).subscribe(
      (result) => {
        if (result.status) {
          this.districtsBasedOnState = result.data;
        }
      }
    );
  }

  async GetBlocks(e: any): Promise<void> {
    this.form.get('block')?.setValue('');
    const districtId = e.target.value;
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.BLOCK.GETBLOCKBASEDONDISTRCIT, { DistrictId: districtId }).subscribe(
      (result) => {
        if (result.status) {
          this.blocksBasedonDistricts = result.data;
        }
      }
    );
  }

  async GetBlocksOnBack(districtId: any): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.BLOCK.GETBLOCKBASEDONDISTRCIT, { DistrictId: districtId }).subscribe(
      (result) => {
        if (result.status) {
          this.blocksBasedonDistricts = result.data;
        }
      }
    );
  }

  async loadOrganizationType(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETORGANIZATIONTYPE).subscribe(
      (result) => {
        if (result.status) {
          this.organizationType = result.data;
        }
      }
    );
  }

  onWhatsAppChange() {
    if (this.form.get('isWhatsAppEnabled')?.value) {
      this.form.get('alternateContactNumber')?.setValue('');
      this.form.get('alternateContactNumber')?.clearValidators();
      this.isWhatsAppSelected = true;
    } else {
      // If WhatsApp is not selected, add validation to the alternate contact number field
      this.form.get('alternateContactNumber')?.setValidators([Validators.required, Validators.pattern(this.commonService.mobilePattern)]);
      this.isWhatsAppSelected = false;
    }
    this.form.get('alternateContactNumber')?.updateValueAndValidity();
  }

   SendtoPreview(form: any) {
     form.get('udyamRegistrationNumber')?.setValue(this.formData.MsMeUserName.value);         

    if (!this.form.get('isWhatsAppEnabled')?.value) {
      this.form.get('alternateContactNumber')?.setValidators([Validators.required, Validators.pattern(this.commonService.mobilePattern)]);
      this.isWhatsAppSelected = false;
    }

    if (this.form.get('isWhatsAppEnabled')?.value) {
      this.form.get('alternateContactNumber')?.setValue('');
      this.form.get('alternateContactNumber')?.clearValidators();
      this.form.get('alternateContactNumber')?.updateValueAndValidity();
      this.isWhatsAppSelected = true;
    }

    if (this.isUdyamVerified) {
      this.form.controls['udyamCertificate'].setErrors(null); // Clears any custom errors if set
     }

    if (form.valid) {
      if (this.nicEntries.length === 0 && !this.isUdyamVerified) {
        this.toastrService.error('Please add at least one NIC Code before proceeding');
        return;
      }
      if (this.plantUnits.length === 0 && !this.isUdyamVerified) {
        this.toastrService.error('Please add at least one plant unit and location before proceeding');
        return;
      }
      if (this.selectedInterests.length === 0) {
        this.toastrService.error('Please add at least one Interest before proceeding');
        return;
      }      

      const selectedEntTypeId = form.get('typeOfEnterprise').value;
      const selectedEntType = this.enterpriseType.find(type => type.id == selectedEntTypeId);

      const selectedOrgTypeId = form.get('typeofOrganization').value;
      const selectedOrgType = this.organizationType.find(type => type.organizationTypeId == selectedOrgTypeId);

      const selectedSocialCatId = form.get('socialCategory').value;
      const selectedSociCat = this.socialCategory.find(type => type.socialCategoryId == selectedSocialCatId);

      const selectedStateId = form.get('stateId').value;
      const selectedState = this.allStates.find(type => type.stateCode == selectedStateId);

      const selectedDistrictId = form.get('districtId').value;
      const selectedDistrict = this.districtsBasedOnState.find(type => type.districtCode == selectedDistrictId);

      const selectedBlockId = form.get('block').value;
      const selectedBlock = selectedBlockId!=null ? this.blocksBasedonDistricts.find(type => type.blockId == selectedBlockId) : null;

      // Extract the documents array from the form (form controls under 'documents' FormArray)
      const documents = this.documents.controls.map((docControl: any) => ({
        name: docControl.get('name')?.value,
        file: docControl.get('file')?.value // This will be the file object (PDF)
      }));

      const selectedInterests = this.selectedInterests.map(interest => ({        
        interestId: interest.interestId,
        interestName: interest.interestName,
      }));

      const nfilteredInterests = this.filteredInterests.map(interest => ({
        interestId: interest.interestId,
        interestName: interest.interestName,
      }));

      if (form.get('dateOfIncorporation')?.value) {
        var doi = form.get('dateOfIncorporation')?.value;
        const value = this.datePipe.transform(doi, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
        form.get('dateOfIncorporation')?.setValue(value);
      }
      if (form.get('dateOfCommencement')?.value) {
        var doc = form.get('dateOfCommencement')?.value;
        const value = this.datePipe.transform(doc, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
        form.get('dateOfCommencement')?.setValue(value);
      }
      const formdatavalue = {
        ...this.formData,
        ...this.getFormValuesIncludingDisabled(),
        dateOfIncorporation: form.get('dateOfIncorporation')?.value || null,
        dateOfCommencement: form.get('dateOfCommencement')?.value || null,
        investmentCost: form.get('investmentCost')?.value || 0,
        SelectedEnterpriseType: selectedEntType ? selectedEntType.name : null,
        SelectedSocialCategory: selectedSociCat ? selectedSociCat.socialCategoryName : null,
        SelectedState: selectedState ? selectedState.StateName : null,
        SelectedDistrict: selectedDistrict ? selectedDistrict.districtName : null,
        SelectedBlock: selectedBlock ? selectedBlock.blockName : null,
        SelectedOrganizationType: selectedOrgType ? selectedOrgType.organizationTypeName : null,
        msmeUserPlantUnitDetails: this.plantUnits,
        msmeUserNICCodeDetails: this.nicEntries,
        msmeUserInterests: selectedInterests,
        udyamCertificateFile: this.certificateFile,
        documents: documents,
        isWhatsAppSelected: this.isWhatsAppSelected,
        isUdyamVerified: this.isUdyamVerified,
        email: this.email?.trim(),
        filIn: nfilteredInterests
      };
      sessionStorage.setItem('personalDetailsCompleted', 'true');
      this.router.navigate(['/msmepreviewpage'], { state: { formData: formdatavalue } });
    } else {
      this.form.markAllAsTouched();
      return;
    }
  }
  get speciallyAbled(): boolean | null {
    const value = this.form.get('areYouAPersonWithDisabilities')?.value;
    return value === 'true' ? true : value === 'false' ? false : null;
  }

  onReset() {
    this.form.reset();
    sessionStorage.clear();
    this.router.navigateByUrl('/app-msmeregister4');
  }

  

  getFormValuesIncludingDisabled() {
    const formValues = this.form.getRawValue();
    return {
      ...formValues,
      plantUnits: this.plantUnits
    };
  }

  addPlantUnit() {
    //Not needed
    if (this.form.get('plantUnitName')?.invalid || this.form.get('locationOfPlantUnit')?.invalid) {
      this.toastrService.error('Plant/Location is not in correct format');
      return; // Don't proceed if the form is invalid
    }

    const plantUnitName = this.form.get('plantUnitName')?.value;
    const locationOfPlantUnit = this.form.get('locationOfPlantUnit')?.value;

    if (plantUnitName && locationOfPlantUnit) {
      const normalizedPlantUnitName = plantUnitName.toLowerCase();
      const normalizedLocationOfPlantUnit = locationOfPlantUnit.toLowerCase();


      // Check for duplicates
      const duplicate = this.plantUnits.some(unit =>
        unit.name.toLowerCase() === normalizedPlantUnitName && unit.location.toLowerCase() === normalizedLocationOfPlantUnit
      );

      if (!duplicate) {
        this.plantUnits.push({ name: plantUnitName, location: locationOfPlantUnit });

        // Reset the input fields after adding
        this.form.get('plantUnitName')?.reset();
        this.form.get('locationOfPlantUnit')?.reset();
      } else {
        this.toastrService.error('This plant unit and location pair already exists.');
      }
    } else {
      this.toastrService.error('Add both plant and location details');
    }
  }

  onNICCodeChange(event: any) {
    const selectedNICCode = event.target.value;
    this.nicForm.patchValue({
      nicCode: selectedNICCode
    });

    // Optionally, fetch the details for the selected NIC code
    this.callNICCodeDetails(selectedNICCode);
  }

  async callNICCodeDetails(nicCode: string) {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.NIC.GETSECTORBASEDONNIC, { nicCode }).subscribe(
      (result) => {
        if (result.status) {
          const nicDetails = result.data[0];
          this.nicForm.patchValue(nicDetails);
        }
      }
    );
  }
 

  addNIC() {

    if (this.nicForm.valid) {

      const selectedNICCode = this.nicForm.value.nicCode;
      const nicItem = this.niclist.find(item => item.nicCode === selectedNICCode);

      if (nicItem) {
        // Create a new entry with the selected nicId and other form values
        const newEntry = {
          nicId: nicItem.nicId, // Include nicId in the entry
          nicCode: selectedNICCode,
          sector: this.nicForm.value.sectorName,
          divisionDescription: this.nicForm.value.divisionName,
          groupDescription: this.nicForm.value.groupName,
          class: this.nicForm.value.className,
          subClass: this.nicForm.value.subClassName
        };

        // Check if the NIC code already exists in nicEntries
        const exists = this.nicEntries.some(entry => entry.nicCode === newEntry.nicCode);
        if (!exists) {
          // Add the new entry to the nicEntries array
          this.nicEntries.push(newEntry);

          // Reset the form after adding the NIC code
          this.nicForm.reset();
          this.resetNICSelection(); // Reset selection to allow a fresh start
        } else {
          this.nicForm.reset();
          this.toastrService.error('This NIC Code is already added.');

        }
      } else {
        this.toastrService.error('NIC Code not found in the list.');
      }
    } else {
      this.toastrService.error('Select NIC code from the given list.');
    }
  }

  resetNICSelection(): void {
    this.form.get('nicCode')?.setValue('');
  }
   
  onUdyamFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      const maxSizeInMB = 10;
      const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB
      this.uploadUdyamError = null;
      this.form.get('udyamCertificate')?.setErrors(null);
      if (file.type !== 'application/pdf') {
        this.uploadUdyamError = 'Only PDF files are allowed.';
        this.certificateFile = null;
      } else if (fileSizeInMB > maxSizeInMB) {
        this.uploadUdyamError = 'File size should not exceed 10 MB.';
        this.certificateFile = null;
      } else if (!new RegExp(this.commonService.fileNamePattern).test(file.name.split('.')[0])) {
        this.uploadUdyamError = 'File name should not contain special characters except -/_/.).';
        this.certificateFile = null;
      } else {
        this.uploadUdyamError = null;
        this.certificateFile = file;
        this.form.get('udyamCertificate')?.setValue(file.name);
      }
    }
    else {
      this.uploadUdyamError = 'Please upload a file.';
      this.form.get('udyamCertificate')?.setErrors({ required: true });
    }
  }

  onUdyamFileChangeBack(event: any) {
    const file = event;
    if (file) {
      const maxSizeInMB = 10;
      const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB
      this.uploadUdyamError = null;
      const control = this.form.get('udyamCertificate');
      if (control) {
        control.setErrors(null);
      }
      if (file.type !== 'application/pdf') {
        this.uploadUdyamError = 'Only PDF files are allowed.';
        this.certificateFile = null;
      } else if (fileSizeInMB > maxSizeInMB) {
        this.uploadUdyamError = 'File size should not exceed 10 MB.';
        this.certificateFile = null;
      } else if (!new RegExp(this.commonService.fileNamePattern).test(file.name.split('.')[0])) {
        this.uploadUdyamError = 'File name should not contain special characters except -/_/.';
        this.certificateFile = null;
      }else {
        this.uploadUdyamError = null;
        this.certificateFile = file;
        this.form.get('udyamCertificate')?.setValue(file.name);         
      }
    } else {
      this.uploadUdyamError = 'Please upload a file.';
      const control = this.form.get('udyamCertificate');
      if (control) {
        control.setErrors({ required: true });
      }
    }
  }
  
  createDocument(): FormGroup {
    return this.fb.group({
      name: ['', (Validators.required)],  
      file: [null, Validators.required]  
    });
  }
  
  get documents(): FormArray {
    return this.form.get('documents') as FormArray;
  }

  // Handle file change event and perform validation
  onFileChange(event: any, index: number): void {
    const file = event.target.files[0];
    const docControl = this.form.get(`documents.${index}.file`);
    const docNameControl = this.form.get(`documents.${index}.name`);

    // Initialize or clear error for this index
    this.uploadError = null;

    if (file) {
      const maxSizeInMB = 10;
      const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB

      // Validate file type
      if (file.type !== 'application/pdf') {
        this.uploadError = `Error for document ${index + 1}: Only PDF files are allowed.`;
        docControl?.setValue(null);
        docNameControl?.clearValidators();
      }
      // Validate file size
      else if (fileSizeInMB > maxSizeInMB) {
        this.uploadError = `Error for document ${index + 1}: File size must not exceed 10 MB.`;
        docControl?.setValue(null);
        docNameControl?.clearValidators();
      }
      else if (!new RegExp(this.commonService.fileNamePattern).test(file.name.split('.')[0])) {
        this.uploadError = 'File name should not contain special characters except -/_/.';
        this.certificateFile = null;
        docControl?.setValue(null);
        docNameControl?.clearValidators(); 
      }
      // Valid file
      else {
        docControl?.setValue(file); // Assign the file
        docNameControl?.setValidators([Validators.required, Validators.pattern(this.commonService.fileNamePattern)]); // Ensure name field is required
      }
    } else {
      // No file selected
      docControl?.setValue(null);
      docNameControl?.clearValidators();
    }

    // Update validators for name control
    docNameControl?.updateValueAndValidity();
  }


  // Add a new document entry
  addMoreDocuments(): void {
    if (this.documents.length < 5) {
      this.documents.push(this.createDocument());
    } else {
      this.uploadError = 'You can only add a maximum of 5 documents.'; // Optional error message
    }
  }

  // Remove a document entry by index
  removeDocument(index: number): void {
    this.documents.removeAt(index);

    // Clear any upload error if the user removed a document and the number is now below the limit
    if (this.uploadError && this.documents.length < 5) {
      this.uploadError = '';
    }
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  blockManualInput(event: KeyboardEvent): void {
    event.preventDefault(); // Prevent keypresses (manual typing)
  }

  openConfirmationDialog(type: string, index: number): void {
    // Pass the type and index to the dialog for dynamic action handling
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { type, index }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Based on the type, call the respective remove function
        switch (type) {
          case 'plantUnit':
            this.removePlantUnit(index);
            break;
          case 'nicEntry':
            this.removeNIC(index);
            break;
          //case 'pair':
          //  this.removePair(index);
          //  break;
        }
      }
    });
  }


  removePlantUnit(index: number) {
    this.plantUnits.splice(index, 1);
  }

  removeNIC(index: number) {
    this.nicEntries.splice(index, 1);

    this.nicForm.patchValue({
      nicCode: '',
      sectorCode: '',
      sectorName: '',
      divisionCode: '',
      divisionName: '',
      groupCode: '',
      groupName: '',
      className: '',
      subClassName: ''
    });
  }
  
  allNICrecord: any[] = [];

  async getNICDataforPDF(): Promise<void> {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.NIC.GETNICDATAFORPDF).subscribe(
      (result) => {
        if (result.status) {
          this.allNICrecord = result.data; 
          const nicDetails = result.data[0];
          this.nicForm.patchValue(nicDetails);
        }
      }
    );
  }
 

  async generatePDF(): Promise<void> {
     
      await this.getNICDataforPDF();

      if (!this.allNICrecord || this.allNICrecord.length === 0) {
        return;
      }      
      const doc = new jsPDF('l', 'mm', 'a4'); // 'l' for landscape

      // Add a title to the PDF
      doc.setFontSize(12);
      doc.text('NIC Details', 14, 10);

      // Define the table column headers
      const tableColumn = ['Sr. No', 'NIC Code', 'Sector Code', 'Sector', 'Division', 'Group', 'Class', 'SubClass'];

      // Define the table rows
      const tableRows: any[] = [];

      // Iterate through the fetched data and prepare the table rows
      this.allNICrecord.forEach((item: any, index: number) => {
        const row = [
          index + 1,          // Sr. No
          item.nicCode,       // NIC Code
          item.sectorCode,    // Sector Code
          item.sector,        // Sector
          item.division,      // Division
          item.group,         // Group
          item.class,         // Class
          item.subClass       // SubClass
        ];
        tableRows.push(row);
      });

      // Use autoTable to generate the table
      autoTable(doc, {
        head: [tableColumn], // Column headers
        body: tableRows,     // Table data
        startY: 20,          // Position where the table starts
        theme: 'striped',    // Apply striped rows
        styles: { fontSize: 10 },
        headStyles: { fillColor: [22, 160, 133] }, // Green header
      });

      // Save the generated PDF
      doc.save('NIC_Details.pdf');
  }


  // Handles checkbox toggle
  toggleInterestSelection(interest: any, event: any): void {
    interest.selected = event.target.checked;
  }

  // Moves selected interests to the right box
  moveSelectedToRight(): void {
    const selected = this.filteredInterests.filter(interest => interest.selected);
    selected.forEach(interest => {
      if (!this.selectedInterests.includes(interest)) {
        this.selectedInterests.push(interest);
      }
      // Remove the interest from the filtered list
      interest.selected = false; // Reset selection
    });
    this.filteredInterests = this.filteredInterests.filter(interest => !selected.includes(interest));
  }

  // Moves selected interests back to the left box
  moveSelectedToLeft(): void {
    const deselected = this.selectedInterests.filter(interest => interest.selected);
    deselected.forEach(interest => {
      if (!this.filteredInterests.includes(interest)) {
        this.filteredInterests.push(interest);
      }
    });
    this.selectedInterests = this.selectedInterests.filter(interest => !interest.selected);

  }

  removeUdyamCertificate(): void {
    this.form.get('udyamCertificate')?.setValue(null); 
    this.certificateFile = null; // Clear the stored file
    this.uploadUdyamError = null; // Reset any error message
  }    

  onCancel(): void {
    const confirmCancel = confirm("Are you sure you want to cancel and go back to the login page?");
    if (confirmCancel) {
      this.router.navigate(['/login']); // Redirect to the login page
    }
  }
  removeExtraSpaces(controlName: string): void {
    const control = this.form.get(controlName);
    if (control && control.value) {
      // Trim leading and trailing spaces and replace multiple spaces with a single space
      const sanitizedValue = control.value.trim().replace(/\s+/g, ' ');
      control.setValue(sanitizedValue);
    }
  }

}
